var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "20%", height: "45%" },
          attrs: {
            title: _vm.title,
            width: 800,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.isReadOnly
                ? _c(
                    "a-button",
                    { key: "back", on: { click: _vm.handleCancel } },
                    [_vm._v("\n        取消\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form, id: "personModal" } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "姓名",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["name", _vm.validatorRules.name],
                            expression: "[ 'name', validatorRules.name]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入姓名" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "类型",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["type", _vm.validatorRules.type],
                              expression: "[ 'type', validatorRules.type]",
                            },
                          ],
                          attrs: { placeholder: "请选择类型" },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "销售员" } },
                            [_vm._v("销售员")]
                          ),
                          _c(
                            "a-select-option",
                            { attrs: { value: "财务员" } },
                            [_vm._v("财务员")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "排序",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["sort"],
                            expression: "[ 'sort' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入排序" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }